import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const forYou = ['Estás sin empleo y necesitas ingresos esta semana', 'Tienes empleo pero quieres un ingreso extra desde tu celular', 'Tienes habilidades básicas — WhatsApp, Instagram, Canva, Google — pero no sabes cómo cobrar por ellas', 'Vives en Colombia, México, Argentina, Venezuela, Chile, Perú o España'];
const notForYou = ['Si buscas un curso largo con certificado', 'Si quieres resultados sin ejecutar nada', 'Si esperas que alguien te contrate'];
export const Comparison = () => {
  return <section className="py-20 md:py-24 bg-dark" data-id="element-29">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-30">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-10" data-id="element-31">
          {/* For you */}
          <FadeIn direction="right" data-id="element-32">
            <div className="bg-[#111111] border border-[#ADFF2F]/30 rounded-2xl p-8 md:p-10 h-full" data-id="element-33">
              <div className="mb-8" data-id="element-34">
                <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-xs mb-2 block" data-id="element-35">
                  Para quién es
                </span>
                <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-36">
                  Esta guía es para ti
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-37">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-38">
                    <span className="shrink-0 w-7 h-7 rounded-full bg-[#ADFF2F]/15 border border-[#ADFF2F]/40 flex items-center justify-center mt-0.5" data-id="element-39">
                      <ArrowRight className="w-4 h-4 text-[#ADFF2F]" strokeWidth={3} data-id="element-40" />
                    </span>
                    <span className="text-base md:text-lg text-gray-200 leading-relaxed font-sans" data-id="element-41">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not for you */}
          <FadeIn direction="left" delay={0.2} data-id="element-42">
            <div className="bg-[#111111] border border-red-500/20 rounded-2xl p-8 md:p-10 h-full" data-id="element-43">
              <div className="mb-8" data-id="element-44">
                <span className="text-red-400 font-bold tracking-[0.2em] uppercase text-xs mb-2 block" data-id="element-45">
                  Para quién no es
                </span>
                <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-46">
                  Esta guía no es para ti
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-47">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-48">
                    <span className="shrink-0 w-7 h-7 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center mt-0.5" data-id="element-49">
                      <X className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-50" />
                    </span>
                    <span className="text-base md:text-lg text-gray-400 leading-relaxed font-sans" data-id="element-51">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};